import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  effect,
  inject,
  Injector,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';
import { SealMediaWatcherService } from '@shipsfocus/seal';
import { VesselReportsSidebarComponent } from '@vessel-reports/components/sidebar/sidebar.component';
import { VesselReportsState } from '@vessel-reports/state/vessel-reports.state';
import { Observable, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'vessel-reports',
  templateUrl: './vessel-reports.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, MatSidenavModule, VesselReportsSidebarComponent]
})
export class VesselReportsComponent implements OnInit, OnDestroy {
  @ViewChild('matDrawer', { static: true }) matDrawer: MatDrawer;
  drawerMode: 'over' | 'side' = 'side';
  drawerOpened: boolean = true;

  private _unsubscribeAll: Subject<any> = new Subject<any>();
  private _injector: Injector = inject(Injector);
  private _vesselReportsState: VesselReportsState = inject(VesselReportsState);
  protected readonly destroyRef: DestroyRef = inject(DestroyRef);

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _sealMediaWatcherService: SealMediaWatcherService
  ) {}

  ngOnInit(): void {
    this._subscribeToSource$(this._sealMediaWatcherService.onMediaChange$, ({ matchingAliases }: any) => {
      if (matchingAliases.includes('lg')) {
        this.drawerMode = 'side';
        this._vesselReportsState.set({ openedSidebarDrawer: true });
      } else {
        this.drawerMode = 'over';
        this._vesselReportsState.set({ openedSidebarDrawer: false });
      }
    });

    // Effect to sync drawer state with state service
    effect(
      () => {
        this.drawerOpened = this._vesselReportsState.openedSidebarDrawer();
        this._changeDetectorRef.markForCheck();
      },
      { injector: this._injector }
    );
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  private _subscribeToSource$<T>(source$: Observable<T>, callback: (value: T) => void): void {
    source$.pipe(takeUntil(this._unsubscribeAll)).subscribe((value: T) => {
      callback(value);

      this._changeDetectorRef.markForCheck();
    });
  }

  closeDrawer() {
    this._vesselReportsState.set({ openedSidebarDrawer: false });
  }
}
